import { isObject } from '@direct-frontend/stdlib';
import type { PersistentSliceInternals } from './types';

type PersistState = NonNullable<PersistentSliceInternals['_persist']>;

function isPersistState(value: unknown): value is PersistState {
    return isObject(value) && typeof value.version === 'number' && typeof value.rehydrated === 'boolean';
}

/**
 * `_persist` из стейта слайса; `undefined`, если это не стейт persistent-слайса или хранилище еще не читалось.
 */
export function getPersistState(sliceState: unknown): PersistState | undefined {
    return isObject(sliceState) && isPersistState(sliceState._persist) ? sliceState._persist : undefined;
}
